export default __webpack_public_path__ + "static/media/logo-negro.bd9eb395.svg";